import { getConfig } from '../Config/ApplicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';

export const checkDeviceToken = (
    authoringSystem: string,
    authoringSystemForeignKey: string
): Promise<CheckDeviceTokenContracts.Response> =>
    getExecutor(getConfig().apiEndpoints.servicesAustralia).post<null, CheckDeviceTokenContracts.Response>(
        `api/v1/devices/${authoringSystem}/${authoringSystemForeignKey}/check-token`,
        null
    );

export namespace CheckDeviceTokenContracts {
    export interface Response {
        success: boolean;
        error: CheckDeviceTokenError;
    }

    export interface CheckDeviceTokenError {
        message: string;
        code: string;
    }
}
